import "./EquipmentFunctionalityType.html";

import "./BasicInformation/BasicInformationComponent";
import "./IOProperties/IOPropertiesComponent";
import "./VideoProperties/VideoPropertiesComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EquipmentFunctionalityTypeComponentController from "./EquipmentFunctionalityTypeComponentController";

export default class EquipmentFunctionalityTypeComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            functionalityTypeId: "<",
        };
        this.controller = EquipmentFunctionalityTypeComponentController;
        this.templateUrl = "/App/Components/EquipmentFunctionalityType/EquipmentFunctionalityType.html";
    }
}

module("mmManagePortal").component("irEquipmentFunctionalityTypeDetails", new EquipmentFunctionalityTypeComponent());
